import request from '../../../axios';

const postPaymentStorePlans = async (payload: IPaymentStorePlansPayload) => {
  const {data}: {data: IPaymentStorePlansData} = await request.post(
    '/api/v2/subscription/payment-store-plans',
    payload,
  );
  return data;
};

export default postPaymentStorePlans;
